import { render, staticRenderFns } from "./ed-course-create-course-material-object.vue?vue&type=template&id=1a56acac&scoped=true&"
import script from "./ed-course-create-course-material-object.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-course-material-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-course-material-object.scss?vue&type=style&index=0&id=1a56acac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56acac",
  null
  
)

export default component.exports